module.exports = __webpack_public_path__ + "img/table-edit-20x20.5f4a7821.svg";